export default __webpack_public_path__ + "static/media/Welding Machine SEDA ACDC.5bdd7922.png";